import React, {useState, useEffect, Fragment, } from "react";
import Logo2 from "../../../../../src/images/logo2.svg";
import Logo from "../../../../../src/images/logo.svg";
import {Button, Modal} from "react-bootstrap";
import OrderChat from "../../../common/OrderChat";
import {
  sendOrderMessageAction,
  setActiveOrderAction,
  setOrderMessageAction,
  updateActiveOrdersAction,
  updateOrderMessageAction,
  updateOrderMessagesAction
} from "../../../../store/actions/OrdersActions";
import {handleAlert} from "../../../../services/AlertService";
import {useDispatch, useSelector} from "react-redux";
import {ActionCableConsumer} from "react-actioncable-provider";
import CommonOrder from "../../../common/Orders/CommonOrder";
import { useHistory } from "react-router-dom";
import {useTranslation} from "react-i18next";
import TelegramLoginButton from "react-telegram-login";
import {submitProfileAction, submitTelegramAction} from "../../../../store/actions/AuthActions";
import {getActiveOrders} from "../../../../services/OrderService";
import {CountdownCircleTimer} from "react-countdown-circle-timer";
import {isFirebaseSupported, isMobileSafari} from "../../../common/utils";
import Toggle from "react-toggle";

const ActiveOrders = (props) => {
  const [currentImage, setCurrentImage] = useState(Logo2);
  const storeOrders = useSelector(store => store.orders);
  const storeAuth = useSelector(store => store.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [state, setState] = useState({
    activeOrdersModal: false,
    selectedOrder: !!activeOrders()[0] && activeOrders()[0].id
  });
  const fromLocal = localStorage.getItem('activeOrders');

  useEffect(() => {
    if (!!fromLocal) {
      const activeOrders = Object.values(JSON.parse(fromLocal));
      setCurrentImage(orderTime(activeOrders[0]) < new Date().getTime() ? Logo : Logo2)
    }
  }, []);

  function sendMessage(text) {
    dispatch(sendOrderMessageAction(state.selectedOrder, text));
  }

  function updateMessagesSeen(orderId) {
    if (!!storeOrders.activeOrders[orderId] && unseenMessages(orderId) > 0) {
      const containUnseen = Object.values(storeOrders.activeOrders[orderId].messages).some((m) => !m.seen);
      if (containUnseen) {
        dispatch(updateOrderMessageAction(orderId));
      }
    }
  }

  function changeOrderStatus(data) {
    if (!!data.order_message) {
      if (data.order_message.user_id !== storeAuth.auth.userData.id) {
        setState({...state, activeOrdersModal: true, selectedOrder: data.order_message.messageable_id});
        if (!(!!storeAuth.auth.userData && !!storeAuth.auth.userData.devices && storeAuth.auth.userData.devices.length > 0)) {
          handleAlert('info', `${t('ordering')} ${data.order_message.messageable_id}`, data.order_message.text, 5000);
        }
      }
      dispatch(setOrderMessageAction(data.order_message.messageable_id, data.order_message));
      if (state.activeOrdersModal && data.order_message.messageable_id === state.selectedOrder) {
        updateMessagesSeen(data.order_message.messageable_id)
      }
    } else if (!!data.order && !data.message && !history.location.pathname.includes('/orders/')) {
      if (!(!!storeAuth.auth.userData && !!storeAuth.auth.userData.devices && storeAuth.auth.userData.devices.length > 0)) {
        handleAlert('default', `${t('ordering')} ${data.order.id}`, t(`orderStatuses.${data.order.status}`));
      }
    } else if (!!data.order_message_update) {
      dispatch(updateOrderMessagesAction(data.order_message_update.order_id, data.order_message_update.messages))
    }
    if (!!data.order) {
      dispatch(setActiveOrderAction(data.order));
    }
  }

  function selectOrder(orderId) {
    if (''+state.selectedOrder === ''+orderId) {
      setState({...state, activeOrdersModal: false});
      if (history.location.pathname.includes('/orders/') && !history.location.pathname.includes(`${orderId}`)) {
        window.location.href = `/orders/${orderId}`;
      } else {
        history.push(`/orders/${orderId}`);
      }
    } else {
      setState({...state, selectedOrder: orderId});
    }
    updateMessagesSeen(orderId);
  }

  function activeOrders() {
    return Object.values(storeOrders.activeOrders).filter((o) => o.status === 'created' ||
      o.status === 'payed' || o.status === 'cooking' || o.status === 'ready' || o.status === 'on_delivery')
  }

  function openActiveOrdersModal() {
    getActiveOrders().then((resp) =>
      dispatch(updateActiveOrdersAction(resp.data.active_orders))
    ).catch(() =>
      dispatch(updateActiveOrdersAction({}))
    );
    const orderId = state.selectedOrder || activeOrders()[0].id;
    setState({...state, activeOrdersModal: true, selectedOrder: orderId});
    updateMessagesSeen(orderId);
  }

  function closeOrderMessages() {
    updateMessagesSeen(state.selectedOrder);
    setState({...state, activeOrdersModal: false})
  }

  function unseenMessages(orderId) {
    let count = 0;
    if (!!orderId) {
      activeOrders().filter((o) => o.id === orderId).map((o) => {
        Object.values(o.messages).map((m) => {
          if (!m.seen && (m.user_id !== storeAuth.auth.userData.id)) {
            count += 1
          }
        })
      });
    } else {
      activeOrders().map((o) => {
        Object.values(o.messages).map((m) => {
          if (!m.seen && (m.user_id !== storeAuth.auth.userData.id)) {
            count += 1
          }
        })
      });
    }
    return count;
  }

  function onMessageType() {
    updateMessagesSeen(state.selectedOrder);
  }

  function shouldBePayed() {
    if (!!storeOrders.activeOrders[state.selectedOrder] &&
        storeOrders.activeOrders[state.selectedOrder].status === 'created' &&
        storeOrders.activeOrders[state.selectedOrder].payment_type === 'pre_pay') {
      return storeOrders.activeOrders[state.selectedOrder];
    }
  }

  const handleTelegramResponse = response => {
    dispatch(submitTelegramAction(response, history));
  };

  const orderTime = (order) => {
    return order.time + (1000 * 60 * order.delay)
  };

  const timer = ({ remainingTime }) => {
    const hours = Math.floor(remainingTime / 3600);
    const minutes = Math.floor((remainingTime % 3600) / 60);
    const seconds = remainingTime % 60;

    if (minutes < 1 && hours === 0) {
      return `${seconds}`
    } else {
      return `${hours}:${minutes < 10 ? `0${minutes}` : minutes}`
    }
  };

  return (
    <>
      { activeOrders().length > 0 &&
        <>
          { activeOrders().map((o) =>
            <ActionCableConsumer key={o.id}
              channel={{channel: 'OrderChannel', room: o.id}}
              onReceived={(data) => changeOrderStatus(data)}
            />)}

          <div onClick={openActiveOrdersModal} id='active-orders'
            className={`active-orders ${(activeOrders()[0].status === 'created' || activeOrders()[0].status === 'payed' ||
              orderTime(activeOrders()[0]) < new Date().getTime()+100) && 'opacity'}`}
          >
            {unseenMessages() > 0 && <span className='selected-dishes fs-16'>{unseenMessages()}</span>}
            { (activeOrders()[0].status === 'created' || activeOrders()[0].status === 'payed' ||
               orderTime(activeOrders()[0]) < new Date().getTime()+100) ?
              <img width='80' height='80' src={currentImage}/>
            :
              <CountdownCircleTimer
                key={`${activeOrders()[0].id}`}
                isPlaying
                initialRemainingTime={(orderTime(activeOrders()[0]) - new Date().getTime())/1000}
                duration={(orderTime(activeOrders()[0]) - activeOrders()[0].created_integer)/1000}
                colors={['#28a645', '#ffa605', '#f35757', '#A30000']}
                colorsTime={[(orderTime(activeOrders()[0]) - activeOrders()[0].created_integer)/1000, 300, 60, 0]}
                children={timer}
                size={60}
                strokeWidth={6}
                onComplete={() => {setCurrentImage(Logo)}}
                className='order-timer'
              />}
          </div>

          <Modal className="fade" show={state.activeOrdersModal}>
            <Modal.Header>
              <Modal.Title className='text-black'>{t('activeOrders.modalHeader')}</Modal.Title>
              <Button variant="" className="close" onClick={closeOrderMessages}>
                <span>&times;</span>
              </Button>
            </Modal.Header>
            <Modal.Body style={{height: 'calc(100vh - 140px)'}}>
              <div className='d-flex orders active-orders-tabs'>
                { activeOrders().map((o, i) =>
                  <div key={i} className={`active-order ${''+state.selectedOrder === ''+o.id && 'selected'}`}
                       onClick={() => selectOrder(o.id)}
                  >
                    {unseenMessages(o.id) > 0 && <span className='selected-dishes fs-16'>{unseenMessages(o.id)}</span>}
                    <CommonOrder order={o}/>
                  </div>)}
              </div>
              { isFirebaseSupported() && !storeAuth.auth.userData.working &&
                <div className='card-body'>
                  <p className='text-black'>{t('activeOrders.telegramNotice')}</p>
                  <div className="media align-items-center">
                    <div className="media-body d-flex align-items-center justify-content-between">
                      <h6 className="mb-0 mr-1 text-black">{t('components.profile.pushNotify')}</h6>
                      <Toggle id='telegram-push' checked={storeAuth.auth.userData.working}
                        onChange={() => dispatch(submitProfileAction({working: !storeAuth.auth.userData.working}, props.history))}/>
                    </div>
                  </div>
                </div>}
              { !storeAuth.auth.userData.telegram_id && !!storeOrders.activeOrders[state.selectedOrder] &&
                  !!storeOrders.activeOrders[state.selectedOrder].messages &&
                  Object.keys(storeOrders.activeOrders[state.selectedOrder].messages).length === 0 &&
                <div className='text-center mt-2'>
                  <TelegramLoginButton dataOnauth={handleTelegramResponse}
                                       botName={process.env.REACT_APP_TELEGRAM_BOT_NAME} />
                </div>}
              { !!storeOrders.activeOrders[state.selectedOrder] &&
                <div className='mt-4'>
                  { Object.keys(storeOrders.activeOrders[state.selectedOrder].messages).length === 0 &&
                    <h6 className='text-center'>{t('components.order.noMessages')}</h6>}
                  <OrderChat sendMessage={sendMessage} onMessageType={onMessageType} orderToPay={shouldBePayed()}
                    messages={storeOrders.activeOrders[state.selectedOrder].messages || {}}
                    restaurant={storeOrders.activeOrders[state.selectedOrder].restaurant}
                  />
                </div>}
            </Modal.Body>
          </Modal>
        </>}
    </>
  );
};

export default ActiveOrders;